import { CurrentUserAdStatus } from './types';
import { AdStatus } from '@/types';

export function getCurrentUserAdStatus(status: AdStatus): CurrentUserAdStatus {
  if (status === AdStatus.Published) return 'PUBLISHED';

  return status;
}
